<template>

	<v-btn :block="block"
		   class="appButton-container"
		   :color="color || 'black'"
		   :dark="!disabled"
		   depressed
		   :disabled="disabled"
		   :height="height || 48"
		   :loading="loading">

		<app-icon v-if="icon" class="mr-2" :icon="icon" :size="iconSize" :color="iconColor"/>

		{{ label }}

		<v-img v-if="['Log In', 'Register', 'Reset'].includes(label)"
			   :src="require('@/assets/images/logo-fitap-rings.svg')"
			   class="ml-4"/>

	</v-btn>

</template>

<script>
export default {

	name: "AppBtn",

	props: [
		'block',
		'color',
		'disabled',
		'height',
		'icon',
		'iconColor',
		'iconSize',
		'label',
		'loading',
	],

}
</script>

<style scoped>
.appButton-container {
	border-radius: 8px;
	box-shadow: 0 0 0 1px white;
}
</style>
